import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../pages/Authentication/Login"
import ForgotPassword from "../pages/Authentication/ForgotPassword";
import TvScreen from "../pages/SuperAdminPages/TvScreen";
function UnAuthenticatedRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/tv-screen" element={<TvScreen />} />
    </Routes>
  );
}

export default UnAuthenticatedRoutes;
